import React from 'react';
import {ReactComponent as Arrow} from 'images/playlist/arrow.svg';
import './ArrowButton.styl';

export default class ArrowButton extends React.PureComponent {
  render() {
    return (
      <div className="arrow-button">
        <Arrow />
      </div>
    );
  }
}
